import React from 'react';
import { Table2, BarChart3, Type, Plus } from 'lucide-react';

const SectionToolbox = ({ onAddSection }) => {
  const sectionTypes = [
    {
      id: 'table',
      name: 'Table',
      description: 'Display data in table format with columns and rows',
      icon: Table2,
      color: 'blue'
    },
    {
      id: 'chart',
      name: 'Chart',
      description: 'Visualize data with bar, pie, or trend charts',
      icon: BarChart3,
      color: 'green'
    },
    {
      id: 'text',
      name: 'Text',
      description: 'Add rich text content and static sections',
      icon: Type,
      color: 'purple'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800 hover:bg-blue-100 dark:hover:bg-blue-900/30',
      green: 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800 hover:bg-green-100 dark:hover:bg-green-900/30',
      purple: 'bg-purple-50 dark:bg-purple-900/20 border-purple-200 dark:border-purple-800 hover:bg-purple-100 dark:hover:bg-purple-900/30'
    };
    return colors[color] || colors.blue;
  };

  const getIconColorClasses = (color) => {
    const colors = {
      blue: 'text-blue-600 dark:text-blue-400',
      green: 'text-green-600 dark:text-green-400',
      purple: 'text-purple-600 dark:text-purple-400'
    };
    return colors[color] || colors.blue;
  };

  return (
    <div className="space-y-3">
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
        Click a section type to add it to your report
      </p>
      
      {sectionTypes.map((sectionType) => {
        const Icon = sectionType.icon;
        return (
          <button
            key={sectionType.id}
            onClick={() => onAddSection(sectionType.id)}
            className={`w-full p-4 rounded-lg border-2 transition-all duration-200 text-left ${getColorClasses(sectionType.color)}`}
          >
            <div className="flex items-start gap-3">
              <div className={`p-2 rounded-lg bg-white dark:bg-gray-800 ${getIconColorClasses(sectionType.color)}`}>
                <Icon className="w-5 h-5" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-gray-900 dark:text-gray-100 flex items-center gap-2">
                  {sectionType.name}
                  <Plus className="w-4 h-4" />
                </h4>
                <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                  {sectionType.description}
                </p>
              </div>
            </div>
          </button>
        );
      })}

      <div className="pt-4 mt-4 border-t border-gray-200 dark:border-gray-700">
        <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-3">
          <h4 className="text-sm font-semibold text-blue-900 dark:text-blue-100 mb-1">
            💡 Tip
          </h4>
          <p className="text-xs text-blue-800 dark:text-blue-200">
            Arrange sections on the canvas by dragging them. Click a section to edit its properties.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SectionToolbox;

